module.exports = __webpack_public_path__ + "img/David_Headshot-photoaidcom-cropped.1948f384.JPG";